import { Network } from '@types';

function useGetNetworkName(): (n: Network) => string {
  function getName(n: Network): string {
    switch (n) {
      case Network.Cronos:
        return 'Cronos EVM';
      case Network.Ethereum:
        return 'Ethereum';
      case Network.CryptoOrg:
        return 'Cronos POS';
      case Network.Cosmos:
        return 'Cosmos';
      case Network.Terra:
        return 'Terra';
      case Network.Juno:
        return 'Juno';
      case Network.Akash:
        return 'Akash';
      case Network.Canto:
        return 'Canto';
      case Network.Iris:
        return 'Iris';
      case Network.Celestia:
        return 'Celestia';
      default:
        return '';
    }
  }

  return getName;
}

export default useGetNetworkName;
